export default {"src":"/_next/static/media/PINS.0a0dc765.svg","height":18,"width":18};